import React, { FC, useCallback, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from "@mui/material";
import { AlertContext } from "../../contexts/AlertContext";

interface IProps {
    children: React.ReactNode
}

// Replaces native window.alert() app-wide - a real MUI Dialog instead,
// since a browser-native alert can be suppressed by the user/browser
// ("prevent this page from creating additional dialogs"), silently
// dropping the message. One instance mounted at the app root; any
// component calls useAlert() to show it.
export const AlertContainer: FC<IProps> = ({ children }) => {
    const [message, setMessage] = useState<string | null>(null);

    const showAlert = useCallback((msg: string) => setMessage(msg), []);
    const handleClose = () => setMessage(null);

    return (
        <AlertContext.Provider value={{ showAlert }}>
            {children}
            <Dialog open={!!message} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogContent>
                    <DialogContentText sx={{ whiteSpace: "pre-line", color: "text.primary" }}>
                        {message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant="contained" disableElevation autoFocus>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </AlertContext.Provider>
    );
};
